export default function Stats({ items }) {
	if (!items.length)
		return (
			<footer className='stats'>
				<em>🏝️ You should pack Your Items 🎒</em>
			</footer>
		);

	const itemList = items.length;

	if (itemList === 20)
		alert('You have 20 items on your list, you should stop 🛑');

	const packedItems = items.filter((item) => item.packed === true).length;

	const percentage = Math.round((packedItems / itemList) * 100);

	return (
		<footer className='stats'>
			<em>
				{percentage === 100
					? 'you are ready to go 🏝️'
					: `🎒 You have ${itemList} Items on Your list, and you already packed 
				${packedItems} (${percentage}%) `}
			</em>
		</footer>
	);
}
